import React from 'react';

export type ShiftResponseValue = 'accept' | 'decline' | null;

export const ShiftResponseToggle: React.FC<{
  value: ShiftResponseValue;
  onChange: (value: ShiftResponseValue) => void;
  acceptDisabled?: boolean;
  declineDisabled?: boolean;
  declineTooltip?: string;
}> = ({
  value,
  onChange,
  acceptDisabled = false,
  declineDisabled = false,
  declineTooltip = 'Decline',
}) => {
  const base =
    'tw:w-5 tw:h-5 tw:flex tw:items-center tw:justify-center tw:rounded tw:border tw:transition-colors tw:!rounded-sm';

  const disabledStyles = 'tw:bg-zinc-100 tw:text-zinc-400 tw:border-zinc-200 tw:cursor-not-allowed';

  const acceptStyles = acceptDisabled
    ? disabledStyles
    : value === 'accept'
      ? 'tw:bg-stoplight-success tw:text-white tw:border-stoplight-success tw:cursor-pointer'
      : 'tw:bg-white tw:text-zinc-400 tw:border-zinc-400 tw:hover:border-stoplight-success tw:hover:text-stoplight-success tw:cursor-pointer';

  const declineStyles = declineDisabled
    ? disabledStyles
    : value === 'decline'
      ? 'tw:bg-stoplight-danger tw:text-white tw:border-stoplight-danger tw:cursor-pointer'
      : 'tw:bg-white tw:text-zinc-400 tw:border-zinc-400 tw:hover:border-stoplight-danger tw:hover:text-stoplight-danger tw:cursor-pointer';

  return (
    <div className="tw:flex tw:gap-1 tw:rounded-lg">
      {!acceptDisabled && (
        <button
          type="button"
          className={`${base} ${acceptStyles}`}
          onClick={() => onChange(value === 'accept' ? null : 'accept')}
          title="Accept"
        >
          <i className="fas fa-check tw:text-xs" />
        </button>
      )}
      {!declineDisabled && (
        <button
          type="button"
          className={`${base} ${declineStyles}`}
          onClick={() => onChange(value === 'decline' ? null : 'decline')}
          title={declineTooltip}
        >
          <i className="fas fa-xmark tw:text-xs" />
        </button>
      )}
    </div>
  );
};
